// ** Icons Import
import { Circle, Grid } from "react-feather";

export default [
  {
    id: "admin",
    title: "Admin",
    badge: "light-primary",
    badgeText: "4",
    icon: <Grid size={20} />,
    children: [
      {
        id: "pricingEngine",
        title: "Pricing Engine",
        icon: <Circle size={12} />,
        navLink: "/pricing-engine",
      },
      {
        id: "users",
        title: "Users",
        icon: <Circle size={12} />,
        navLink: "/users",
      },
      {
        id: "event",
        title: "Events",
        icon: <Circle size={12} />,
        navLink: "/events",
      },
      {
        id: "logs",
        title: "Logs",
        icon: <Circle size={12} />,
        navLink: "/logs",
      },
    ],
  },
];
